import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import Swal from 'sweetalert2';
import { FormLabel, Select, MenuItem } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import request from '../../../services/Request';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { Controller, useController } from 'react-hook-form';
import { FormControl, InputLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const updateAdress = '/machines/updateAdress';

export default function EditAlphModal(props) {
  const classes = useStyles();
  const { data, user, setReflesh, reflesh, setshow, id, ...rest } = props;

  const defaultValues = {
    ini_user_credit: data?.alphUserFields?.ini_user_credit || 0,
    refresh_credit: data?.alphUserFields?.refresh_credit || 0,
    refresh_period: data?.alphUserFields?.refresh_period || 0,
  };

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
    control,
    watch,
  } = useForm({ defaultValues });

  const watchAllFields = watch();

  useEffect(() => {
    if (props.show) {
      reset(defaultValues);
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    console.log('date', formData.p_date);
    // return console.log('formData', formData);

    request({
      method: 'patch',
      url: `/alphUserFields`,
      data: {
        id: id,
        ini_user_credit: formData.ini_user_credit,
        refresh_credit: formData.refresh_credit,
        refresh_period: formData.refresh_period,
      },
    }).then(() => {
      Swal.fire({
        title: 'Success',
        text: 'User has been successfully updated',
        timer: 2000,
      });
      setshow(false);
      setReflesh(!reflesh);
    });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <div>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2} style={{ textAlignLast: 'center' }}>
                {/* <Select onChange={handleChange}>
                  {field.map((field) => (
                    <MenuItem key={field._id} value={field._id}>
                      {field.service}
                    </MenuItem>
                  ))}
                </Select> */}

                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.ini_user_credit || 0}
                    variant="outlined"
                    fullWidth
                    label="Initial User Credit"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('ini_user_credit', {})}
                  />
                  {errors.ini_user_credit && (
                    <p className="signUpErrorMessage">{errors.ini_user_credit.message}</p>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.refresh_credit || 0}
                    variant="outlined"
                    fullWidth
                    label="Refresh Credit"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('refresh_credit', {})}
                  />
                  {errors.refresh_credit && (
                    <p className="signUpErrorMessage">{errors.refresh_credit.message}</p>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.refresh_period || 0}
                    variant="outlined"
                    fullWidth
                    label="Refresh Period"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('refresh_period', {})}
                  />
                  {errors.refresh_period && (
                    <p className="signUpErrorMessage">{errors.refresh_period.message}</p>
                  )}
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Update
              </Button>
            </form>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
